module.exports = __webpack_public_path__ + "static/media/rambu cajaWEB.01ac8771.jpg";